export const appTypesNames = {
  allApps: "All Apps"
};
